import { TERMS_ACCEPTANCE_LOG_PREFIX } from './termsAcceptanceConstants';
function skipInfoInTest() {
    return typeof process !== 'undefined' && process.env.NODE_ENV === 'test';
}
export function logTermsAcceptance(event, details, level = 'info', cause) {
    if (level === 'info' && skipInfoInTest()) {
        return;
    }
    const meta = details != null && Object.keys(details).length > 0 ? { event, ...details } : { event };
    const line = `${TERMS_ACCEPTANCE_LOG_PREFIX} ${event}`;
    switch (level) {
        case 'error':
            if (cause !== undefined) {
                console.error(line, meta, cause);
            }
            else {
                console.error(line, meta);
            }
            break;
        case 'warn':
            console.warn(line, meta);
            break;
        default:
            console.info(line, meta);
    }
}
